import { Search } from 'lucide-react';

interface SearchTriggerProps {
    onSearchOpen: () => void;
}

const SearchTrigger = ({ onSearchOpen }: SearchTriggerProps) => {
    return (
        <div
            onClick={onSearchOpen}
            className="w-full rounded-xl px-2 py-2 cursor-pointer transition-colors flex items-center space-x-3"
            style={{ backgroundColor: '#40474F' }}
        >
            <Search size={16} className="text-gray-400" />
        </div>
    );
};

export default SearchTrigger;